import Vue from 'vue';
var NotificationsService = /** @class */ (function () {
    function NotificationsService() {
    }
    NotificationsService.prototype.Notify = function (header, content) {
        Vue.notify({
            group: 'foo',
            title: header,
            text: content
        });
    };
    return NotificationsService;
}());
var NotificationsSvc = new NotificationsService();
export default NotificationsSvc;
